import as from './As/Config';

export default {
  ...as,
};
